import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import { useTheme } from '../../contexts/ThemeContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const GlobalLoading: React.FC = () => {
  const { isLoading } = useLoading();
  const { colors } = useTheme();

  if (!isLoading) {
    return null;
  }

  return (
    <div className={`fixed inset-0 ${colors.background} bg-opacity-90 z-50 flex items-center justify-center`}>
      <LoadingSpinner fullScreen={false} message="Loading..." size="large" />
    </div>
  );
};

export default GlobalLoading;

